export default "__VITE_ASSET__BZf$q2Ed__"